var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#EEEEEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    stroke: "#555555",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 5.7198C9.1434 5.7198 9.28676 5.77455 9.39607 5.88381L12.8359 9.32366C13.0547 9.54248 13.0547 9.89725 12.8359 10.116C12.6172 10.3347 12.2625 10.3347 12.0436 10.116L9.00002 7.07221L5.95641 10.1159C5.73759 10.3346 5.38292 10.3346 5.16421 10.1159C4.94529 9.89715 4.94529 9.54237 5.16421 9.32356L8.60398 5.8837C8.71334 5.77442 8.8567 5.7198 9.00002 5.7198Z",
    fill: "#555555",
    stroke: "#555555",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.3c3e562a43ddf70714b8e78a8a164174.svg";
export { ForwardRef as ReactComponent };